import { Translation } from '@ps/web-shared-components';
import React from 'react';
import { useDispatch } from 'react-redux';

import type { Dispatch } from '@swf/core/store';

import LearnMoreIcon from '../../../../assets/icons/learn-more.svg';
import type { Tournament } from '../../../../types/MTT';

import {
  TXTCLI_N0_Satellites_Available,
  TXTCLI_for_as_little_as_N0
} from './SatellitesList.messages.json';
import styles from './SatellitesList.scss';

export interface SatellitesProps {
  satellitesModalPath?: string;
  satellites?: Tournament[];
}
const SatellitesList: React.FC<SatellitesProps> = ({
  satellitesModalPath = '',
  satellites = []
}) => {
  if (!satellites?.length) return null;

  const { modal } = useDispatch<Dispatch>();
  const formattedBuyIn = satellites.reduce(
    (min, current) => (current.buyIn < min.buyIn ? current : min),
    satellites[0]
  )?.formattedBuyIn;

  return (
    <div
      className={styles.root}
      onClick={() =>
        modal.unshift({
          path: satellitesModalPath,
          locationState: { satellites }
        })
      }
    >
      <Translation
        tagName="span"
        {...TXTCLI_N0_Satellites_Available}
        values={{ 0: satellites.length }}
      />{' '}
      <Translation tagName="span" {...TXTCLI_for_as_little_as_N0} values={{ 0: formattedBuyIn }} />
      <LearnMoreIcon />
    </div>
  );
};

export default SatellitesList;
